import store from "@/study-search/store";
import { computed } from 'vue';
import { BreadcrumbsFactory } from "@/study-search/domain/BreadcrumbsFactory";

export default class Breadcrumbs {
	filters = computed(() => store.getters.getFilters());
	breadcrumbs = computed(()=> BreadcrumbsFactory.generateBreadcrumbs(this.filters.value));
}
